module.exports = __webpack_public_path__ + "img/Logo3.0ccafe57.png";